import { css } from '@emotion/css';

export const iconStyle = css`
  path {
    fill: currentColor;
  }
`;
